export const BOOK_STATUS_LIST = [
  {
    name: 'Не выбрано',
    value: 0,
  },
  {
    name: 'Новая',
    value: 1,
  },
  {
    name: 'Проверена',
    value: 2,
  },
  {
    name: 'Удалена',
    value: 3,
  },
  {
    name: 'Архив',
    value: 4,
  },
  {
    name: 'Изъята',
    value: 5,
  },
];
